import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import GalleryService from "../../services/gallery.service";


export const getGallery = createAsyncThunk(
    "gallery/getGallery",
    async (params, thunkAPI) => {
        try {
            const response = await GalleryService.getGallery(params);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const addGallery = createAsyncThunk(
    "gallery/addGallery",
    async (data, thunkAPI) => {
        try {
            const response = await GalleryService.addGallery(data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const updateGallery = createAsyncThunk(
    "gallery/updateGallery",
    async (payload, thunkAPI) => {
        try {
            const response = await GalleryService.editGallery(payload);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

export const deleteGallery = createAsyncThunk(
    "gallery/deleteGallery",
    async (id, thunkAPI) => {
        try {
            await GalleryService.deleteGallery(id);
            return id;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);



const initialState = {
    loading: false,
    error: null,
    galleryList: [],
    updateSuccess: false,
};



const gallerySlice = createSlice({
    name: "gallery",
    initialState,
    reducers: {
        resetUpdateStatus: (state) => {
            state.updateSuccess = false;
        },
    },
    extraReducers: (builder) => {
        builder

            //   get
            .addCase(getGallery.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getGallery.fulfilled, (state, action) => {
                state.loading = false;
                state.galleryList = action.payload?.data || [];
            })
            .addCase(getGallery.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // add
            .addCase(addGallery.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addGallery.fulfilled, (state, action) => {
                state.loading = false;
                const newimages =
                    action.payload?.data ||
                    action.payload?.gallery ||
                    action.payload;

                if (newimages) {
                    state.galleryList.unshift(newimages);
                }
            })
            .addCase(addGallery.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // update
            .addCase(updateGallery.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.updateSuccess = false;
            })
            .addCase(updateGallery.fulfilled, (state, action) => {
                state.loading = false;
                state.updateSuccess = true;

                const updated =
                    action.payload?.data || action.payload?.gallery;

                if (updated?._id) {
                    const index = state.galleryList.findIndex(
                        (item) => item._id === updated._id
                    );
                    if (index !== -1) {
                        state.galleryList[index] = updated;
                    }
                }
            })
            .addCase(updateGallery.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteGallery.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteGallery.fulfilled, (state, action) => {
                state.loading = false;
                state.galleryList = state.galleryList.filter(
                    (item) => item._id !== action.payload
                );
            })
            .addCase(deleteGallery.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdateStatus } = gallerySlice.actions;
export default gallerySlice.reducer;
